import { Component, Input } from '@angular/core';
import { ApplicationVersionService } from 'src/app/services/application-version.service';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  @Input() bbapp: boolean = true;
  applicationVersion: string = '';
  translations: any;

  constructor(private langservice: LanguageService,
    private versionService: ApplicationVersionService,
    private translationservice: TranslationService)
  { }

  ngOnInit() {
    this.translationservice.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });

    this.versionService.getAppVerison().subscribe({
      next:(data) => {
        this.applicationVersion = data.version;
      }
    });
  }
}
